import React, { useState } from 'react';
import { Package, Trash2 } from 'lucide-react';
import { WheelProduct } from '../../../../../types';

interface WheelProductItemProps {
  wheelProduct: WheelProduct;
  onUpdateOddsWeight: (oddsWeight: number) => void;
  onRemove: () => void;
}

const WheelProductItem: React.FC<WheelProductItemProps> = ({
  wheelProduct,
  onUpdateOddsWeight,
  onRemove
}) => {
  const [oddsWeight, setOddsWeight] = useState(wheelProduct.odds_weight);

  const handleOddsWeightChange = (newOddsWeight: number) => {
    setOddsWeight(newOddsWeight);
    onUpdateOddsWeight(newOddsWeight);
  };

  const stockTone =
    wheelProduct.stock > 10 ? 'text-musgo'
      : wheelProduct.stock > 0 ? 'text-mostarda-dark'
        : 'text-bordo';

  return (
    <div className="flex items-center gap-4 p-4 bg-white border border-tinta/10 rounded-lg hover:border-tinta/20 transition-all">
      {wheelProduct.image_url ? (
        <img
          src={wheelProduct.image_url}
          alt={wheelProduct.name}
          className="w-16 h-16 rounded-lg object-cover flex-shrink-0 border border-tinta/10"
        />
      ) : (
        <div className="w-16 h-16 bg-creme-light border border-tinta/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Package size={24} className="text-tinta-soft/60" />
        </div>
      )}

      <div className="flex-1 min-w-0">
        <h4 className="font-bold text-tinta truncate leading-tight">{wheelProduct.name}</h4>
        <p className="text-sm mt-0.5">
          <span className="text-tinta-soft">Estoque disponível: </span>
          <span className={`font-bold ${stockTone}`}>{wheelProduct.stock}</span>
        </p>
      </div>

      <div className="flex items-center gap-3 flex-shrink-0">
        <div className="flex items-center gap-2 px-2.5 py-1 rounded-md bg-mostarda/15 border border-mostarda/40">
          <span className="text-xs font-bold uppercase tracking-wider text-mostarda-dark">Peso</span>
          <input
            type="number"
            min="1"
            value={oddsWeight}
            onChange={(e) => handleOddsWeightChange(parseInt(e.target.value) || 1)}
            className="w-16 bg-white border border-tinta/15 rounded px-2 py-1 text-sm text-tinta focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo"
          />
        </div>

        <button
          onClick={onRemove}
          className="text-tinta-soft hover:text-bordo hover:bg-bordo/8 rounded-md p-1.5 transition-colors"
          title="Remover da roda"
        >
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
};

export default WheelProductItem;
